import { inject, Injectable } from '@angular/core';
import {
	DocumentReference,
	Firestore,
	doc,
	docData,
} from '@angular/fire/firestore';
import { LoadingService } from '@services/loading.service';
import { ConfirmationService } from 'primeng/api';

export interface Version {
	backend: string;
	frontend: string;
}

@Injectable({
	providedIn: 'root',
})
export class VersionService {
	private readonly loadingService = inject(LoadingService);
	private readonly firestore = inject(Firestore);
	private readonly confirmationService = inject(ConfirmationService);
	private _version!: string;

	public listenVersion(): void {
		docData(
			doc(this.firestore, `global/version`) as DocumentReference<Version>
		).subscribe((v) => {
			if (!v) return;
			console.log({ v });
			this._version = v.frontend;
			const version = localStorage.getItem('version');
			console.log('Version: ', version, ' - ', this._version);
			if (!version) {
				localStorage.setItem('version', this._version);
			} else if (version !== this._version) {
				this.confirmationService.confirm({
					header: 'Nueva versión disponible!',
					message: `${version} -> ${this._version}`,
					accept: async () => {
						await this.handleAccept();
					},
					acceptButtonProps: { label: 'Actualizar' },
					rejectVisible: false,
					icon: 'pi pi-info-circle',
					key: 'versionDialog',
					position: 'bottom',
					closable: false,
				});
			}
		});
	}

	private async handleAccept(): Promise<void> {
		this.loadingService.show();
		localStorage.setItem('version', this._version);
		window.location.reload();
	}

	public get version(): string {
		return this._version;
	}
}
